import React, { useState } from "react";
import shuffleIcon from "../icons/shuffle.svg";

const Modal = (props) => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const createSelections = () => {};

  const setSlide = (direction) => {
    if (currentSlide <= 1 && direction == -1) {
      setCurrentSlide(1);
    } else if (currentSlide >= 5 && direction == 1) {
      setCurrentSlide(5);
    } else {
      setCurrentSlide(currentSlide + direction);
    }
  };

  const createSlides = () => {
    return (
      <>
        <div className={`slide ${currentSlide === 1 ? "is-active" : ""}`}>
          <span>1</span> Vali arvloto, millele soovid lipikut luua.
        </div>
        <div className={`slide ${currentSlide === 2 ? "is-active" : ""}`}>
          <span>2</span>
          <p>
            Sisesta oma numbrid või vajuta pliks-plaks nupule
            <img
              alt=""
              className="icon"
              style={{ transform: "scale(1)", margin: "0 2px 0 7px" }}
              src={shuffleIcon}
            ></img>
            , et genereerida juhunumbrid.
          </p>
        </div>
        <div className={`slide ${currentSlide === 3 ? "is-active" : ""}`}>
          <span>3</span>
          Vajuta nupule “Lisa lipikule“ .
        </div>
        <div className={`slide ${currentSlide === 4 ? "is-active" : ""}`}>
          <span>4</span> Kui sa ei soovi teisi mänge lipikule lisada, siis
          vajuta “Loo lipik“ .
        </div>
        <div className={`slide ${currentSlide === 5 ? "is-active" : ""}`}>
          <span>5</span> Avaneb leht QR-Koodiga, näita seda müüjale
          skanneerimiseks.
        </div>
      </>
    );
  };

  return (
    <>
      <div className="modal">
        <button className="close" onClick={() => props.showModal(false)}>
          ✕
        </button>
        <div className="modal--inside">
          <div className="modal--content">{createSlides()}</div>
          <div className="modal--navigation">
            <button
              disabled={currentSlide === 1 && true}
              className="navButton navButton--prev"
              onClick={() => setSlide(-1)}
            >
              Eelmine
            </button>
            <div className="bullets">
              <span
                className={`bullet ${currentSlide === 1 ? "is-active" : ""}`}
              ></span>
              <span
                className={`bullet ${currentSlide === 2 ? "is-active" : ""}`}
              ></span>
              <span
                className={`bullet ${currentSlide === 3 ? "is-active" : ""}`}
              ></span>
              <span
                className={`bullet ${currentSlide === 4 ? "is-active" : ""}`}
              ></span>
              <span
                className={`bullet ${currentSlide === 5 ? "is-active" : ""}`}
              ></span>
            </div>
            <button
              disabled={currentSlide === 5 && true}
              className="navButton navButton--next"
              onClick={() => setSlide(+1)}
            >
              Järgmine
            </button>
          </div>
          <a
            className="link"
            target="_blank"
            href="https://eestiloto.zendesk.com/hc/et-ee/articles/22697417111325-Digilipik"
          >
            Loe lähemalt
          </a>
        </div>
      </div>
      <div className="modalBg" onClick={() => props.showModal(false)}></div>
    </>
  );
};
export default Modal;
